import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';
import Container from '../Container/Container';
import { Link } from 'gatsby';

const fontSize = ['12px', '14px', '14px'];
const SimpleFooter = () => {
  const textColor = '#202020';
  return (
    <Box as="footer" bg={'#F5F8FC'} py={2.5}>
      <Container size={'large'}>
        <Flex gap={[4, '3.25rem']}>
          <Text
            color={textColor}
            fontSize={fontSize}
            as={Link}
            to="https://petchemist.brainfish.ai/"
            target="_blank"
          >
            Help Center
          </Text>
          <Text color={textColor} fontSize={fontSize} as={Link} to="/returns-and-refunds">
            Refunds Policy
          </Text>
          <Text color={textColor} fontSize={fontSize} as={Link} to="/delivery">
            Delivery Policy
          </Text>
        </Flex>
      </Container>
    </Box>
  );
};

export default SimpleFooter;
